module.exports = __webpack_public_path__ + "img/Battery1.dff83065.svg";